import * as React from 'react';
import SxProps from 'threads5/themes/sx-props';
import type { ITheme } from 'threads5/themes/theme';
import { Stack } from 'src/components-v2/Layout';
import Link from 'src/components-v2/Inputs/Link/Link';
import { ConditionalWrapper } from 'src/components-v2/Helpers';

interface ITimelineCtaProps {
  sx?: SxProps<ITheme>;
  children: React.ReactNode;
  href?: string;
}

const TimelineCta: React.FunctionComponent<ITimelineCtaProps> = ({
  children,
  sx,
  href,
}) => {
  return (
    <ConditionalWrapper
      condition={href}
      wrapper={(descendants) => {
        return (
          <Link href={href}>
            <a>{descendants}</a>
          </Link>
        );
      }}
    >
      <Stack
        flexDirection='row'
        gap={3}
        sx={{
          padding: '2.0rem 0',
          borderTop: 'solid 1px',
          borderColor: 'black900',
          '& img': {
            maxWidth: { xs: 'none', sm: 'none', md: '100%' },
          },
          ...sx,
        }}
      >
        {children}
      </Stack>
    </ConditionalWrapper>
  );
};

export default TimelineCta;
